<template>
    <div class="story-maker-sticker-menu-location">
        <div class="header-menu">
            <p>{{ $t('dash.post-creator.story.location-title') }}</p>
        </div>
        <div class="search-bar">
            <i class="fa-regular fa-magnifying-glass"></i>
            <input :placeholder="$t('dash.post-creator.overlay.search')" v-model="models.search">
        </div>

        <div class="list-item hide-scrollbar">
            <span class="loader" v-if="stateLoader"></span>
            <div class="item" v-else v-for="(place,index) in (models.search ? locations : dataInstagramDefault.locations)" @click="selectPlace(place)" :key="`location${index}`">
            
                <div class="info">
                    <p class="location">{{ place.name }}</p>
                    <p class="location-info">{{  place.location.street || place.location.city || place.location.country || place.location.zip  ? `${place.location.street || ''} ${place.location.city || ''} ${place.location.country || ''} ${place.location.zip || ''}` : place.name}}</p>
                </div>
        
            </div>
            
        </div>
    </div>
</template>

<script>
    import store from '@/store/index.js';
    import minxinPost from '@/components/mixins/Posts.vue'

    export default {
        mixins: [minxinPost],

        props: {
            dataInstagramDefault: Object,
        },

        data() {
            return {
                models: {
                    search : ''
                },
                stateLoader: false,
                timeoutInitSearch: null,
                locations: []
            }
        },


        methods: {
            async searchPlace() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = false
                if(!this.models.search) return
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                    this.locations = []
               
                    if (page) {
                        this.stateLoader = true
                        this.locations = (await this.getLocation(page.id, this.models.search)).body.locations
                        this.stateLoader = false
                    }
                },1000)
                
            },

            async selectPlace(place) {
                this.$emit('addSticker','location', {
                    data: {
                        place,
                        styleVariant: 1
                    }
                })
            }
        },

        watch: {
            ['models.search'](newValue, oldValue) {
                this.searchPlace()
              
            },
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>